import { render, staticRenderFns } from "./PlantVarietyList.vue?vue&type=template&id=336dbc20&"
import script from "./PlantVarietyList.vue?vue&type=script&lang=js&"
export * from "./PlantVarietyList.vue?vue&type=script&lang=js&"
import style0 from "./PlantVarietyList.vue?vue&type=style&index=0&id=336dbc20&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports